import { createSlice } from "@reduxjs/toolkit";

const initialOverviewTabUserProfileNewState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  allGames: [],
  freeGameData: {},
  paidGameData: {},
  freepaidGameData: {},
  detailedCoinSummary: {},
  overallCoinSummary: {},
  overallRMGSummary: {},
  rewards: {},
  userInfo: {},
  currencyList: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const OverviewTabUserProfileNewSlice = createSlice({
  name: "overviewTabUserProfileNew",
  initialState: initialOverviewTabUserProfileNewState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
    },

    allGamesList: (state, action) => {
      const { allGames } = action.payload;
      state.listLoading = false;
      state.allGames = allGames;
    },
    usersLedgerReportList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    freeGameData: (state, action) => {
      console.log("action.paylod freeGameData", action.payload);
      const { fetchFreeGameData } = action.payload;
      state.listLoading = false;
      state.freeGameData = fetchFreeGameData;
    },
    paidGameData: (state, action) => {
      console.log("action.paylod", action.payload);
      const { fetchPaidGameData } = action.payload;
      state.listLoading = false;
      state.paidGameData = fetchPaidGameData;
    },
    freepaidGameData: (state, action) => {
      console.log("action.paylod", action.payload);
      const { fetchFreePaidGameData } = action.payload;
      state.listLoading = false;
      state.freepaidGameData = fetchFreePaidGameData;
    },
    detailedCoinSummary: (state, action) => {
      console.log("action.paylod", action.payload);
      const { fetchDetailedCoinSummary } = action.payload;
      state.actionsLoading = false;
      state.detailedCoinSummary = fetchDetailedCoinSummary;
    },
    overallCoinSummary: (state, action) => {
      console.log("action.paylod", action.payload);
      const { fetchOverallCoinSummary } = action.payload;
      state.actionsLoading = false;
      state.overallCoinSummary = fetchOverallCoinSummary;
    },
    overallRMGSummary: (state, action) => {
      console.log("action.paylod", action.payload);
      const { fetchOverallRMGSummary } = action.payload;
      state.listLoading = false;
      state.overallRMGSummary = fetchOverallRMGSummary;
    },
    rewards: (state, action) => {
      console.log("action.paylod", action.payload);
      const { fetchRewards } = action.payload;
      state.listLoading = false;
      state.rewards = fetchRewards;
    },
    singleNameFetched: (state, action) => {
      state.actionsLoading = false;
      state.userInfo = action.payload?.userInfo;
      state.error = null;
    },
    currencyList: (state, action) => {
      const { currencyList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.currencyList = currencyList?.currencyData || [];
    },
  },
});
